var scrollAnimate = require('../components/scrollAnimate');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var infowindow = new google.maps.InfoWindow();
    // Data passed to gtm events
    var gtmData;
    // Customized map
    var styles = [
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#e9e9e9'
                },
                {
                    'lightness': 17
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f5f5f5'
                },
                {
                    'lightness': 20
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#ffffff'
                },
                {
                    'lightness': 17
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#ffffff'
                },
                {
                    'lightness': 29
                },
                {
                    'weight': 0.2
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#ffffff'
                },
                {
                    'lightness': 18
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#ffffff'
                },
                {
                    'lightness': 16
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f5f5f5'
                },
                {
                    'lightness': 21
                }
            ]
        },
        {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#dedede'
                },
                {
                    'lightness': 21
                }
            ]
        },
        {
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'on'
                },
                {
                    'color': '#ffffff'
                },
                {
                    'lightness': 16
                }
            ]
        },
        {
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'saturation': 36
                },
                {
                    'color': '#333333'
                },
                {
                    'lightness': 40
                }
            ]
        },
        {
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f2f2f2'
                },
                {
                    'lightness': 19
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#fefefe'
                },
                {
                    'lightness': 20
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#fefefe'
                },
                {
                    'lightness': 17
                },
                {
                    'weight': 1.2
                }
            ]
        }
    ];

    // Init GB Map in the center of the viewport
    var latlng = new google.maps.LatLng(53.478062, -2.244666);
    var mapOptions = {
        scrollwheel: false,
        zoom: 5,
        center: latlng,
        styles: styles
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        path: 'M17.5.516C7.85.516 0 7.615 0 16.349c0 9.583 12.166 20.483 15.9 23.583.448.377 1.014.584 1.6.584s1.152-.207 1.6-.584c3.733-3.117 15.9-14 15.9-23.583 0-8.733-7.85-15.833-17.5-15.833zm3.75 7.5a2.5 2.5 0 0 1 2.31 1.543 2.5 2.5 0 0 1-.542 2.724 2.5 2.5 0 0 1-2.724.542 2.5 2.5 0 0 1-1.543-2.31 2.5 2.5 0 0 1 2.5-2.5zm-7.5 0a2.5 2.5 0 0 1 2.31 1.543 2.5 2.5 0 0 1-.542 2.724 2.5 2.5 0 0 1-2.725.542 2.5 2.5 0 0 1-1.543-2.31 2.5 2.5 0 0 1 2.5-2.5zM9.166 18.849a2.5 2.5 0 0 1-2.31-1.543 2.5 2.5 0 0 1 .542-2.724 2.5 2.5 0 0 1 2.724-.542 2.5 2.5 0 0 1 1.543 2.31 2.5 2.5 0 0 1-2.5 2.5zm8.333 8.75c-3.683 0-6.667-1.867-6.667-4.167a3.45 3.45 0 0 1 1.667-2.717c.941-.68 1.687-1.593 2.167-2.65.224-.586.608-1.097 1.109-1.475s1.099-.606 1.724-.658c.637.041 1.249.263 1.763.641s.909.896 1.137 1.492c.461 1.049 1.184 1.962 2.1 2.65a3.45 3.45 0 0 1 1.667 2.717c0 2.3-2.983 4.167-6.667 4.167zm8.333-8.75a2.5 2.5 0 0 1-2.31-1.543 2.5 2.5 0 0 1 .542-2.724 2.5 2.5 0 0 1 2.724-.542 2.5 2.5 0 0 1 1.543 2.31 2.5 2.5 0 0 1-2.5 2.5z',
        fillColor: '#2D5843',
        fillOpacity: 1,
        scale: 1.1,
        strokeColor: 'white',
        strokeWeight: 1,
        anchor: new google.maps.Point(13, 30),
        labelOrigin: new google.maps.Point(12, 12)
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            // Set gtm data
            gtmData = {storeName: item.name};
        });
        // We need the modal to be open so we can get the address as fallback in gtm.js
        google.maps.event.addListener(infowindow, 'domready', function () {
            $('body').trigger('gtm:stockistClick', {storeName: item.name});
        });
        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // We need the modal to be open so we can get the address as fallback in gtm.js
    google.maps.event.addListener(infowindow, 'domready', function () {
        $('body').trigger('gtm:stockistClick', gtmData);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };

    var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            $('body').trigger('gtm:stockistFind', {payload: payload, count: data.stores.length});
        }
    });
    return false;
}

function detectLocationPopup() {
    navigator.geolocation.getCurrentPosition(function (position) {
        var url = $('.store-locator').data('action');
        var radius = $('.results').data('radius');
        var urlParams = {
            radius: radius,
            lat: position.coords.latitude,
            long: position.coords.longitude
        };

        url = appendToUrl(url, urlParams);
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                updateStoresResults(data);
            }
        });
    });
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('body').on('keypress', '.store-locator-container', (function (e) {
            if (e.which == 13) {
                e.preventDefault();
                search($(this).find('.btn-storelocator-search[type="button"]'));
            }
        }));
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },

    showMoreButton: function () {
        $('.locator-title-content').each(function () {
            var $title = $(this).find('.locator-subtitle');
            if ($title.text().length > 75) {
                var shortText = $title.text();
                shortText = shortText.substring(0, 75);
                var btnTextMore = $('.locator-title-content').data('btn-more');
                var btnTextLess = $('.locator-title-content').data('btn-less');
                $title.addClass('fullText').hide();
                $title.append(' ' + '<span class="see-less-link">' + btnTextLess +'</span>');
                $(this).append('<div class="previewText">'+ shortText + '... ' + '<span class="see-more-link">' + btnTextMore + '</span></div>');
            }
        });

        $(document).on('click', '.see-more-link', function () {
            $(this).hide();
            $('.previewText').hide();
            $('.fullText').show();
        });

        $(document).on('click', '.see-less-link', function () {
            $('.see-more-link').show();
            $('.fullText').hide();
            $('.previewText').show();
        });
    },
    activeCard: function () {
        $(document).on('click', '.store-locator-container .card-body', function () {
            $('.store-locator-container .card-body').removeClass('active');
            $(this).addClass('active');
        });
    },
    showStore: function () {
        // Show store on map when click on store's info in results
        $(document).on('click', '.results-card [data-name], .results-card [data-address]', function () {
            var storeName = $(this).data('name') || $(this).data('address');

            var element = $('[aria-label=\'' + storeName + '\']');
            element.trigger('click');

            scrollAnimate($('.jumbotron map-canvas'));
        });
    },
    showStoreHours: function () {
        $(document).on('click', '.store-hours-title', function () {
            $('.store-hours-list').slideToggle(500);
            $(this).toggleClass('collapsed');
        });
    },

    showLocationPopup: function () {
        // Detect location when user enters the page
        window.onload = function () {
            detectLocationPopup();
        };
    }
};
